import BaseApi from "../../BaseApi";
export default abstract class BaseAdminApi extends BaseApi {
	protected override apiUrl: string = `${this.apiUrl}/admin`;
}
